"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Input = _interopRequireDefault(require("./Input"));
var _icon = require("../icon");
var _configProvider = require("../config-provider/configProvider");
var _utils = require("../utils");
var _excluded = ["className", "iconRender", "visibilityToggle"];
/* istanbul ignore file */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PassWord = function PassWord(props) {
  var _iconRender;
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var PREFIX = getPrefixCls('input-password');
  var className = props.className,
    iconRender = props.iconRender,
    _props$visibilityTogg = props.visibilityToggle,
    visibilityToggle = _props$visibilityTogg === void 0 ? true : _props$visibilityTogg,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    passwordVisible = _useState2[0],
    setPasswordVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    switchIconVisible = _useState4[0],
    setSwitchIconVisible = _useState4[1];
  var handlePasswordIconClick = function handlePasswordIconClick() {
    var newVal = !passwordVisible;
    setPasswordVisible(newVal);
    if ((0, _utils.isObject)(visibilityToggle) && visibilityToggle.onVisibleChange) {
      visibilityToggle.onVisibleChange(newVal);
    }
  };
  var icon = (_iconRender = iconRender === null || iconRender === void 0 ? void 0 : iconRender(passwordVisible)) !== null && _iconRender !== void 0 ? _iconRender : null;
  // 将开发者自定义的Icon绑定onClick事件
  var iconWithClick = icon ? /*#__PURE__*/_react.default.cloneElement(icon, {
    onClick: handlePasswordIconClick
  }) : null;
  (0, _react.useEffect)(function () {
    setSwitchIconVisible(!!visibilityToggle);
    if ((0, _utils.isObject)(visibilityToggle) && (0, _utils.isBoolean)(visibilityToggle.visible)) {
      // 如果visibilityToggle是对象且visible属性为布尔值，则使用visible属性值
      setPasswordVisible(visibilityToggle.visible);
    }
  }, [visibilityToggle]);
  return /*#__PURE__*/_react.default.createElement(_Input.default, _objectSpread(_objectSpread({}, restProps), {}, {
    className: (0, _classnames.default)("".concat(PREFIX), className),
    clearable: false,
    type: passwordVisible ? 'text' : 'password',
    suffix: switchIconVisible ? iconWithClick || ( /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      className: "".concat(PREFIX, "-visible-icon"),
      onClick: handlePasswordIconClick,
      type: passwordVisible ? 'visibility-on-o' : 'visibility-off-o'
    })) : null
  }));
};
PassWord.displayName = 'PassWord';
var _default = exports.default = PassWord;